var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatchRegistered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11598_39101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7036 4C16.6207 4 16.5536 4.06716 16.5536 4.15V9.84826C16.5536 9.9311 16.6207 9.99826 16.7036 9.99826H17.85C17.9328 9.99826 18 9.9311 18 9.84826V4.15C18 4.06716 17.9328 4 17.85 4H16.7036Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.642857 2.42493H10.85C10.9328 2.42493 11 2.49208 11 2.57493V3.72136C11 3.8042 10.9328 3.87136 10.85 3.87136H1.44643V15.1214H8.35C8.43284 15.1214 8.5 15.1885 8.5 15.2714V16.4178C8.5 16.5006 8.43284 16.5678 8.35 16.5678H0.642857C0.287277 16.5678 0 16.2805 0 15.9249V3.06778C0 2.7122 0.287277 2.42493 0.642857 2.42493Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95379 10.2731H3.47478C3.44866 10.2731 3.42857 10.2008 3.42857 10.1124V9.14814C3.42857 9.05975 3.44866 8.98743 3.47478 8.98743H5.95379C5.97991 8.98743 6 9.05975 6 9.14814V10.1124C6 10.2008 5.97991 10.2731 5.95379 10.2731Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57122 13.166H7.8018C7.88015 13.166 7.94444 13.0937 7.94444 13.0053V12.041C7.94444 11.9526 7.88015 11.8803 7.8018 11.8803H3.57122C3.49287 11.8803 3.42859 11.9526 3.42859 12.041V13.0053C3.42859 13.0937 3.49287 13.166 3.57122 13.166Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0972 2.3125C16.1667 2.38194 16.2014 2.46528 16.2014 2.5625C16.2014 2.65972 16.1667 2.74306 16.0972 2.8125L15.3333 3.5764L14.1528 2.39583L14.9444 1.60417C15.0139 1.53472 15.088 1.5 15.1667 1.5C15.2454 1.5 15.3195 1.53472 15.3889 1.60417L16.0972 2.3125ZM7.65 10.2292C7.56716 10.2292 7.5 10.162 7.5 10.0792V9.11076C7.5 9.07097 7.5158 9.03282 7.54393 9.00469L13.625 2.92362L14.8055 4.10417L8.72448 10.1852C8.69635 10.2134 8.65819 10.2292 8.61841 10.2292H7.65Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5893 9.54822C11.1926 9.54822 9.25 11.4909 9.25 13.8875C9.25 16.2842 11.1926 18.2268 13.5893 18.2268C15.9859 18.2268 17.9286 16.2842 17.9286 13.8875C17.9286 11.4909 15.9859 9.54822 13.5893 9.54822ZM14.4873 12.3607H15.3772C15.5078 12.3607 15.5842 12.5094 15.5058 12.6159L13.2116 15.79C13.1473 15.8784 13.0167 15.8784 12.9525 15.79L11.4699 13.7388C11.3935 13.6324 11.4699 13.4837 11.6004 13.4837H12.4864C12.5119 13.4835 12.537 13.4894 12.5598 13.5009C12.5825 13.5125 12.6021 13.5293 12.617 13.55L13.081 14.1909L14.3567 12.427C14.3868 12.3848 14.435 12.3607 14.4873 12.3607Z",
    fill: "#52C41A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11598_39101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchRegistered);
export default __webpack_public_path__ + "static/media/BatchRegistered.d5aeb6bdad665398a9452f6086a8cf9b.svg";
export { ForwardRef as ReactComponent };